<div class="dashboard-card clearfix">
  <div class="header clearfix">
    <h4>{{'ui.operational'|translate}}</h4>
    <jbm-plant-selector [plants]="plants" [selection]="plantId" [showLabel]="false" class="float-start ms-3"
      (onSelectionChange)="plantChange($event)">
    </jbm-plant-selector>
    <dashboard-day-filter class="float-start ml-4" (onDateChange)="dateChange($event)"></dashboard-day-filter>
  </div>
  <div class="section mt-0">
    <dashboard-summary [data]="summary" ></dashboard-summary>
    <div class="row mt-4">
      <div *ngIf="plantId===-1" class="col-6">
        <dashboard-plants-production [plants]="plantsData"></dashboard-plants-production>
      </div>
      <div *ngIf="plantId>0" class="col-6">
        <dashboard-order-status [orderStatus]="ordersStatus"></dashboard-order-status>
      </div>
      <div class="col-6">
        <dashboard-project-deviations [plantId]="plantId" [deviations]="deviationsSummary"></dashboard-project-deviations>
      </div>
    </div>
    <div class="mt-4">
        <dashboard-order-deliveries [deliveries]="orderDeliveries"></dashboard-order-deliveries>
    </div>
  </div>
  <dashboard-plant-capacities [capacities]="plantCapacities"></dashboard-plant-capacities>
</div>
